import React from 'react';

/**
 * A small badge component to indicate that a field is in read-only mode
 */
export const ReadOnlyBadge: React.FC = () => {
  return (
    <span className="readonly-badge">
      Read Only
    </span>
  );
};

export default ReadOnlyBadge;
